import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { RefreshCw, ChevronRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/Brand";
import { routeSummary, firstDate } from "@/lib/helpers";
import { t } from "@/lib/i18n";

export default function DriverHome() {
  const { lang } = useOutletContext();
  const [orders, setOrders] = useState(null);
  const [tab, setTab] = useState("active");
  const load = () => api.get("/driver/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  useEffect(() => {
    load();
  }, []);

  const shown = (orders || []).filter((o) => (tab === "active" ? o.status !== "unloaded" : o.status === "unloaded"));

  return (
    <div>
      <div className="flex items-end justify-between">
        <h1 className="font-display text-4xl font-extrabold uppercase">{t(lang, "my_orders")}</h1>
        <button onClick={load} data-testid="driver-refresh-btn" className="rounded-full p-2 text-slate-400 hover:bg-white/5" title={t(lang, "refresh")}>
          <RefreshCw className="h-5 w-5" />
        </button>
      </div>
      <div className="mt-5 flex gap-1 rounded-xl border border-white/10 bg-black/30 p-1">
        {["active", "completed"].map((k) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`driver-tab-${k}`}
            className={`flex-1 rounded-lg py-2.5 text-sm font-semibold transition-colors ${tab === k ? "bg-[#1E293B] text-white" : "text-slate-400"}`}>
            {t(lang, k)}
          </button>
        ))}
      </div>
      <div className="mt-4 space-y-3" data-testid="driver-orders-list">
        {orders === null && <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-blue-500" /></div>}
        {orders && !shown.length && <p className="py-10 text-center text-slate-500" data-testid="driver-no-orders">{t(lang, "no_orders")}</p>}
        {shown.map((o, i) => (
          <Link key={o.id} to={`/driver/orders/${o.id}`} data-testid={`driver-order-card-${o.id}`}
            className="fade-up flex items-center gap-3 rounded-xl border border-white/10 bg-[#111827] p-4 transition-colors active:bg-[#1E293B]" style={{ animationDelay: `${i * 60}ms` }}>
            <div className="min-w-0 flex-1">
              <StatusBadge status={o.status} lang={lang} />
              <div className="mt-2 font-display text-2xl font-bold uppercase leading-tight">{routeSummary(o.stops)}</div>
              <div className="mt-1 font-mono text-xs text-slate-400">{o.reference} {firstDate(o.stops) && `· ${firstDate(o.stops)}`}</div>
            </div>
            <ChevronRight className="h-5 w-5 shrink-0 text-slate-500" />
          </Link>
        ))}
      </div>
      <p className="mt-10 text-center text-xs text-slate-600">{t(lang, "install_hint")}</p>
    </div>
  );
}
